import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { ApiTransactionsResponseData } from '../types';
import { ACTION_TYPES } from './types';

type ApiTransactionsDataState = {
  data: ApiTransactionsResponseData;
  loading: boolean;
  error: string;
};

const initialState: ApiTransactionsDataState = {
  data: {
    invoices: [],
    total: 0,
  },
  loading: false,
  error: '',
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.TX_DATA_LIST:
      return update(state, {
        loading: {
          $set: true,
        },
      });
    case ACTION_TYPES.TX_DATA_LIST_SUCCESS:
      return update(state, {
        $merge: {
          data: payload.data,
          loading: false,
        },
      });
    case ACTION_TYPES.TX_DATA_LIST_FAILED:
      return update(state, {
        $merge: {
          error: payload.error,
          loading: false,
        },
      });
    default:
      return state;
  }
};
